import React from 'react';
import moment from 'moment-timezone';
import CustomLoading from '../../../util_components/custom_loading';
import CustomModal from '../../../util_components/custom_modal';
import { post_api, get_api } from '../../../../redux/api_funcs';
import { get_api_url } from '../../../../utils/urls';

class SessionLogsViewer extends React.Component {
  state = {
    loading: true,
    replacementLogs: [],
    rescheduleLogs: [],
    statusHistory: [],
    statusHistoryError: false
  };

  componentDidMount() {
    const { sessionUuid, type } = this.props;
    if (type === 'replacement') this.fetchReplacementLogs(sessionUuid);
    if (type === 'reschedule') this.fetchRescheduleLogs(sessionUuid);
    if (type === 'status') this.fetchStatusHistory(sessionUuid);
  }

  fetchReplacementLogs = (session_uuid) => {
    const url = get_api_url('get_request_replacement_logs');
    const payload = { session_uuid };

    post_api(url, payload, true)
      .then((res) => {
        const appLogs = res?.data?.request_replacement || [];
        const manualLogs = res?.data?.session_change_teacher_history || [];

        const unified = [
          ...appLogs.flatMap((item) => {
            const logs = item.request_replacement_logs;
            if (logs && logs.length > 0) {
              return logs.map((log) => ({
                mode: 'Teacher Initiated',
                status: log.replacement_request_status || '--',
                teacherName: log.accepted_by_teacher?.name || '--',
                fromTeacherName: item.teacher_name || '--',
                fromTeacherUuid: item.teacher_uuid || '--',
                toTeacherName:
                  log.accepted_by_teacher?.name || item.teacher_transferred_to_name || '--',
                toTeacherUuid:
                  log.accepted_by_teacher?.uuid || item.teacher_transferred_to_uuid || '--',
                time: log.accepted_time || item.created_date,
                doneBy: '--',
                notes:
                  [
                    log.reason_for_replacement,
                    log.details_for_replacement || item.details_for_replacement
                  ]
                    .filter(Boolean)
                    .join(', ') || '--'
              }));
            }
            return [
              {
                mode: 'Teacher Initiated',
                status: item?.status || '--',
                teacherName: item?.teacher_name || '--',
                fromTeacherName: item?.teacher_name || '--',
                fromTeacherUuid: item?.teacher_uuid || '--',
                toTeacherName: item?.teacher_transferred_to_name || '--',
                toTeacherUuid: item?.teacher_transferred_to_uuid || '--',
                time: item?.created_date,
                doneBy: '--',
                notes:
                  [item?.reason_for_replacement, item?.details_for_replacement]
                    .filter(Boolean)
                    .join(', ') || '--'
              }
            ];
          }),
          ...manualLogs.map((log) => ({
            mode: 'Care Team Initiated',
            status: 'Accepted',
            fromTeacherName: log?.original_teacher?.name || '--',
            fromTeacherUuid: log?.original_teacher?.uuid || '--',
            toTeacherName: log?.new_teacher?.name || '--',
            toTeacherUuid: log?.new_teacher?.uuid || '--',
            time: log?.replacement_date,
            doneBy: log?.cms_user?.name || '--',
            notes:
              [log?.reason_for_replacement, log?.details_for_replacement]
                .filter(Boolean)
                .join(', ') || '--'
          }))
        ];

        unified.sort((a, b) => new Date(a.time) - new Date(b.time));

        this.setState({ replacementLogs: unified, loading: false });
      })
      .catch(() => this.setState({ loading: false }));
  };

  fetchStatusHistory = (session_uuid) => {
    const url = get_api_url('get_session_status_history');
    const payload = { session_uuid };

    post_api(url, payload, true)
      .then((res) => {
        this.setState({
          statusHistory: res?.data?.session_status_history || [],
          loading: false
        });
      })
      // distinct error state so a failed fetch isn't shown as "no history"
      .catch(() => this.setState({ loading: false, statusHistoryError: true }));
  };

  // sub_status may arrive as a JSON-encoded array
  formatSubStatus = (value) => {
    if (!value) return '--';
    if (Array.isArray(value)) return value.join(', ') || '--';
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) return parsed.join(', ') || '--';
    } catch (e) {}
    return String(value);
  };

  fetchRescheduleLogs = (session_uuid) => {
    const url = get_api_url('get_session_time_change_history');
    const payload = { session_uuid };

    post_api(url, payload, true)
      .then((res) => {
        this.setState({
          rescheduleLogs: res?.data?.session_change_time_history?.returned_obj_arr || [],
          loading: false
        });
      })
      .catch(() => this.setState({ loading: false }));
  };

  render() {
    const { show, close, type, iana_timezone } = this.props;
    const { loading, replacementLogs, rescheduleLogs, statusHistory, statusHistoryError } =
      this.state;

    return (
      <CustomModal show={show} close={close}>
        {loading ? (
          <CustomLoading />
        ) : type === 'replacement' ? (
          replacementLogs.length > 0 ? (
            <>
              <h3>Replacement Logs</h3>
              <div className="cus-table">
                <div className="ct-row ct-h">
                  <div className="ct-col">Mode</div>
                  <div className="ct-col">Status</div>
                  <div className="ct-col">From Teacher</div>
                  <div className="ct-col">To Teacher</div>
                  <div className="ct-col">Time & Date</div>
                  <div className="ct-col">Done By</div>
                  <div className="ct-col">Notes</div>
                </div>
                {replacementLogs.map((log, idx) => (
                  <div className="ct-row" key={idx}>
                    <div className="ct-col">{log?.mode}</div>
                    <div className="ct-col">{log?.status}</div>
                    {log?.fromTeacherUuid && log?.fromTeacherUuid !== '--' ? (
                      <a
                        className="ct-col link-no-dec cursor-pointer text-[#CC5500]"
                        target="_blank"
                        href={`/teacherprofile?id=${log.fromTeacherUuid}`}
                        rel="noreferrer noopener"
                      >
                        {log?.fromTeacherName}
                      </a>
                    ) : (
                      <div className="ct-col">{log?.fromTeacherName}</div>
                    )}
                    {log?.toTeacherUuid && log?.toTeacherUuid !== '--' ? (
                      <a
                        className="ct-col link-no-dec cursor-pointer text-[#CC5500]"
                        target="_blank"
                        href={`/teacherprofile?id=${log?.toTeacherUuid}`}
                        rel="noreferrer noopener"
                      >
                        {log?.toTeacherName}
                      </a>
                    ) : (
                      <div className="ct-col">{log?.toTeacherName}</div>
                    )}
                    <div className="ct-col">
                      {moment(log?.time).tz(iana_timezone).format('YYYY-MM-DD hh:mm A z')}
                    </div>
                    <div className="ct-col">{log?.doneBy}</div>
                    <div className="ct-col">{log?.notes}</div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div style={{ textAlign: 'center', padding: '20px', fontWeight: 'bold' }}>
              No replacement logs found.
            </div>
          )
        ) : type === 'status' ? (
          statusHistoryError ? (
            <div style={{ textAlign: 'center', padding: '20px', fontWeight: 'bold' }}>
              Failed to load status history
            </div>
          ) : statusHistory.length > 0 ? (
            <>
              <h3>Status History</h3>
              <div className="cus-table">
                <div className="ct-row ct-h">
                  <div className="ct-col">Status</div>
                  <div className="ct-col">Sub status</div>
                  <div className="ct-col">Changed by</div>
                  <div className="ct-col">Date/time</div>
                </div>
                {statusHistory.map((log, idx) => {
                  const actor_name = log?.actor_name || log?.changed_by || '--';
                  return (
                    <div className="ct-row" key={idx}>
                      <div className="ct-col">{log?.status || '--'}</div>
                      <div className="ct-col">{this.formatSubStatus(log?.sub_status)}</div>
                      <div className="ct-col">
                        <div>{log?.changed_by || '--'}</div>
                        {/* skip the second line when there's no name beyond the role */}
                        {actor_name !== (log?.changed_by || '--') ? (
                          <>
                            <hr />
                            <div>{actor_name}</div>
                          </>
                        ) : null}
                      </div>
                      <div className="ct-col">
                        {log?.created_date
                          ? moment(log.created_date)
                              .tz(iana_timezone)
                              .format('YYYY-MM-DD hh:mm A z')
                          : '--'}
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <div style={{ textAlign: 'center', padding: '20px', fontWeight: 'bold' }}>
              No status changes recorded
            </div>
          )
        ) : rescheduleLogs.length > 0 ? (
          <>
            <h3>Reschedule Logs</h3>
            <div className="cus-table">
              <div className="ct-row ct-h">
                <div className="ct-col">Original Time</div>
                <div className="ct-col">New Time</div>
                <div className="ct-col">Action Time</div>
                <div className="ct-col">Changed For</div>
                <div className="ct-col">Changed By</div>
                <div className="ct-col">Reason</div>
              </div>
              {rescheduleLogs.map((log, idx) => (
                <div className="ct-row" key={idx}>
                  <div className="ct-col">
                    <div>
                      {moment(log?.original_session_time).tz(iana_timezone).format('YYYY-MM-DD')}
                    </div>
                    <hr />
                    <div>
                      {moment(log?.original_session_time).tz(iana_timezone).format('hh:mm A z')}
                    </div>
                  </div>
                  <div className="ct-col">
                    <div>
                      {moment(log?.current_session_time).tz(iana_timezone).format('YYYY-MM-DD')}
                    </div>
                    <hr />
                    <div>
                      {moment(log?.current_session_time).tz(iana_timezone).format('hh:mm A z')}
                    </div>
                  </div>
                  <div className="ct-col">
                    <div>{moment(log?.created_date).tz(iana_timezone).format('YYYY-MM-DD')}</div>
                    <hr />
                    <div>{moment(log?.created_date).tz(iana_timezone).format('hh:mm A z')}</div>
                  </div>
                  <div className="ct-col">{log?.reschedule_requested_by || '--'}</div>
                  <div className="ct-col">
                    <div>{log?.requester_type}</div>
                    <hr />
                    {log?.requester_type === 'TEACHER' ? (
                      <a
                        className="link-no-dec cursor-pointer text-[#CC5500]"
                        target="_blank"
                        href={`/teacherprofile?id=${log?.requester_uuid}`}
                        rel="noreferrer"
                      >
                        {log?.requester_name || '--'}
                      </a>
                    ) : (
                      <div>{log?.requester_name || '--'}</div>
                    )}
                  </div>
                  <div className="ct-col">{log?.reason_for_reschedule || '--'}</div>
                </div>
              ))}
            </div>
          </>
        ) : (
          <div style={{ textAlign: 'center', padding: '20px', fontWeight: 'bold' }}>
            No reschedule logs found.
          </div>
        )}
      </CustomModal>
    );
  }
}

export default SessionLogsViewer;
